export const PERSONALIZED_CONTENT_BY_FUNNEL_ROUTE = '/recommendations/personalized_content';
